var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuOpenClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.332,
    height: 9.064,
    viewBox: "0 0 14.332 9.064",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-linecap:round;stroke-width:3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-278.379 -140.379)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "a",
    y1: 4.823,
    x2: 5.045,
    transform: "translate(280.5 142.5)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 5.045,
    y1: 4.823,
    transform: "translate(285.545 142.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuOpenClose);
export default __webpack_public_path__ + "static/media/menu-open-close.f7faa9b6839dd4da23ffac87b9d0a5f5.svg";
export { ForwardRef as ReactComponent };